class WcagSettings {
  constructor(
    selector,
    cookieName,
    cookieExpiration = 365,
    cookieValue = "",
    tag = ""
  ) {
    this.selector = selector;
    this.cookieName = cookieName;
    this.cookieExpiration = cookieExpiration;
    this._cookieValue = cookieValue;
    this.tag = tag;
  }

  get cookieValue() {
    return this._cookieValue;
  }

  set cookieValue(value) {
    if (this.cookieValue !== "") {
      this.removeClassFromTag();
    }

    this._cookieValue = value;
    this.addClassToTag();
    this.setCookie();
    this.setSlectorActive();
  }

  events() {
    const _this = this;

    this.selector.on("click", function(event) {
      event.preventDefault();

      _this.cookieValue = $(this).attr("data-param");
    });
  }

  static getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  setCookie() {
    const d = new Date();
    d.setTime(d.getTime() + this.cookieExpiration * 24 * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie =
      this.cookieName + "=" + this.cookieValue + ";" + expires + ";path=/";
  }

  checkCookie() {
    const getCookieNameValue = WcagSettings.getCookie(this.cookieName);

    if (getCookieNameValue !== "") {
      this.cookieValue = getCookieNameValue;
    }
  }

  addClassToTag() {
    this.tag.addClass(this.cookieValue);
  }

  removeClassFromTag() {
    this.tag.removeClass(this.cookieValue);
  }

  setSlectorActive() {
    let selector = $('[data-param="' + this.cookieValue + '"]');

    this.selector.parent().removeClass("active");
    selector.parent().addClass("active");
  }

  init() {
    this.events();
    this.checkCookie();
  }
}

export default WcagSettings;
